import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { loadRuntimeConfig } from './lib/runtimeConfig.js';
import './index.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found in DOM');
const appRoot = rootEl;

async function bootstrap(): Promise<void> {
  await loadRuntimeConfig();

  const [{ router }, { queryClient }, { theme }, { PlayerProvider }] = await Promise.all([
    import('./router.js'),
    import('./lib/queryClient.js'),
    import('./lib/theme.js'),
    import('./features/player/PlayerProvider.js'),
  ]);

  createRoot(appRoot).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          {/* Above the router: the audio element has to outlive every route. */}
          <PlayerProvider>
            <RouterProvider router={router} />
          </PlayerProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </StrictMode>,
  );
}

void bootstrap().catch((error) => {
  console.error('Failed to start app', error);
  appRoot.innerHTML =
    '<div style="padding:24px;font-family:sans-serif">Failed to load app configuration.</div>';
});
